import React from 'react'
import "./Service.css"

const Service = ({ image, title, arrow,onClick }) => {
  return (

    <div data-aos="zoom-in" >
      <div className='service-container' onClick={onClick} style={{ cursor: 'pointer' }}>
          <img src={image} className='service-image' />
          <div className='service-content'>
              <div className='service-title'>{title}</div>
              {
                arrow && (
                  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="8" viewBox="0 0 39 8" fill="none">
                      <path d="M38.4062 4.35355C38.6014 4.15829 38.6014 3.84171 38.4062 3.64645L35.2242 0.464466C35.0289 0.269204 34.7123 0.269204 34.5171 0.464466C34.3218 0.659728 34.3218 0.976311 34.5171 1.17157L37.3455 4L34.5171 6.82843C34.3218 7.02369 34.3218 7.34027 34.5171 7.53553C34.7123 7.7308 35.0289 7.7308 35.2242 7.53553L38.4062 4.35355ZM0 4.5H38.0526V3.5L0 3.5L0 4.5Z" fill="white"/>
                  </svg>
                )
              }
            
          </div>
      </div>
    </div>
   
  )
}

export default Service